import { isString } from "lodash-es";
import { ensure, TType } from "types";

import { IWithRouteMatchProps, IWithRoutePropsProps } from "@/infrastructure/Route";

export interface IConsultantProfileIdMatchParam {
  consultantProfileId: string;
}

export interface IConsultantProfileIdDetailPathProps {
  consultantProfileId: number;
}

export interface IConsultantProfileIdDetailMatchProps extends IWithRouteMatchProps<IConsultantProfileIdMatchParam> {}
export interface IConsultantProfileIdDetailRouteProps
  extends IWithRoutePropsProps<IConsultantProfileIdDetailPathProps> {}

export interface IJobRequestPathParams {
  jobRequestId: number;
}

export const configMatchParamsType: TType<IConsultantProfileIdDetailPathProps> = {
  consultantProfileId: v => (isString(v) ? parseInt(v, 10) : NaN),
};

export const matchParamsType = ensure<IConsultantProfileIdDetailPathProps>(configMatchParamsType);
